function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 64,
  cy: 40.09,
  r: 36.09
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M124 140.28c-6.48-43.88-33.17-64.23-59.64-64.23S10.49 96.39 4 140.27"
});

var SvgMyVodafone = function SvgMyVodafone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 128 144.28",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgMyVodafone;